
import { Injectable } from "@angular/core";
import Pusher from 'pusher-js';
import { Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { User } from "../../models/user";
import { getCurrentApiDomain, getCurrentBaseDomain } from "../../helpers/helper-functions";

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  baseUrl = getCurrentBaseDomain();


  public funderTasksListSubject = new Subject();

  pusher: any = "";

  constructor() {
    Pusher.logToConsole = true;
    if (this.pusher == "") {
      this.pusher = new Pusher(environment.pusher_secret, {
        cluster: environment.pusher_cluster,
        channelAuthorization:
        {
          endpoint: this.baseUrl + "/broadcasting/auth",
          transport: "ajax",
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('access_token')
          }
        }
      });
    }
  }


  subscribeToChannel(channelName: string, eventNames: string[]): Observable<any> {
    let funderChannel = this.pusher.subscribe(channelName);

    // Stage 5 PR 20 — return a teardown function from the Observable
    // factory so consumer .unsubscribe() actually unbinds the Pusher
    // SDK listeners. Pre-PR-20 the bind() callbacks were created on
    // subscribe but never unbound on unsubscribe; their closures
    // captured observer.next, which captured the component, which
    // meant the destroyed component reference lingered on the Pusher
    // channel object's internal listener list — preventing GC and
    // (theory) accumulating on every dashboard re-mount. Even though
    // PR 14 added websocketService.unsubscribeFromChannel(name) on
    // component destroy (which calls pusher.unsubscribe), the
    // Observable factory's closure still held the channel reference,
    // keeping the listeners alive in memory.
    return new Observable(observer => {
      const bound = eventNames.map(eventName => {
        const handler = (data: any) => observer.next(data);
        funderChannel.bind(eventName, handler);
        return { eventName, handler };
      });
      return () => {
        bound.forEach(({ eventName, handler }) => {
          funderChannel.unbind(eventName, handler);
        });
      };
    });
  }

  subscribeUserToChannel(eventNames: string[]): Observable<any> {
    const user = new User(JSON.parse(localStorage.getItem('user')!));
    let funderChannel = this.pusher.subscribe(`private-user-channel.${user.uuid}`);

    // Stage 5 PR 20 — same teardown fix as subscribeToChannel above.
    return new Observable(observer => {
      const bound = eventNames.map(eventName => {
        const handler = (data: any) => observer.next(data);
        funderChannel.bind(eventName, handler);
        return { eventName, handler };
      });
      return () => {
        bound.forEach(({ eventName, handler }) => {
          funderChannel.unbind(eventName, handler);
        });
      };
    });
  }
  unsubscribeFromChannel(channelName: string) {
    this.pusher.unsubscribe(channelName);
  }

}
